import type { Product } from '@/types/product.types';

/**
 * Available products for laser engraving
 * Images are stored in /public/images/products/ (served at /images/products/)
 */
export const products: Product[] = [
  {
    id: 'black-dog-tag',
    name: 'Black Dog Tag',
    category: 'tag',
    stripeProductId: 'prod_TifApJYl6yBgps', // Stripe Live Product ID
    price: 1000, // $10.00 in cents
    frontPreviewImage: '/images/products/black-dog-tag-back.png', // Simple silhouette for cards/dropdown
    backPreviewImage: '/images/products/black-dog-tag/black-dog-tag-product-cutout.png', // Same as front
    frontExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1773618334/engraving-products/black-dog-tag-base-image-v3.png',
    backExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1773618334/engraving-products/black-dog-tag-base-image-v3.png',
    frontFrameOverlay: '/images/products/black-dog-tag/black-dog-tag-dark-frame.png',
    backFrameOverlay: '/images/products/black-dog-tag/black-dog-tag-dark-frame.png',
    frontProductionFrame: '/images/products/black-dog-tag/black-dog-tag-black-frame.png',
    backProductionFrame: '/images/products/black-dog-tag/black-dog-tag-black-frame.png',
    aiImageWidth: 576,
    aiImageHeight: 992,
    aspectRatio: 0.58, // 576:992 (portrait)
    description: 'Classic military-style dog tag in matte black',
    shippingInfo: { turnaroundDays: '3-5', shippingDays: '2-4' },
  },
  {
    id: 'black-card',
    name: 'Black Card',
    category: 'card',
    stripeProductId: 'prod_TifAIswQFkecMx', // Stripe Live Product ID
    price: 1000, // $10.00 in cents
    frontPreviewImage: '/images/products/black-card-back.png',
    backPreviewImage: '/images/products/black-card-back.png', // Same as front
    frontExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1772766513/engraving-products/black-card-base-image-v2-cutout.png',
    backExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1772766513/engraving-products/black-card-base-image-v2-cutout.png',
    frontFrameOverlay: '/images/products/black-card/black-card-dark-frame.png',
    backFrameOverlay: '/images/products/black-card/black-card-dark-frame.png',
    frontProductionFrame: '/images/products/black-card/black-card-black-frame.png',
    backProductionFrame: '/images/products/black-card/black-card-black-frame.png',
    aiImageWidth: 864,
    aiImageHeight: 1376,
    aiDisplayWidth: 648,
    aiDisplayHeight: 1032,
    canvasWidth: 1024,
    canvasHeight: 1536,
    aspectRatio: 0.628, // 864:1376 (portrait)
    description: 'Sleek black metal card for business or personal use',
    shippingInfo: { turnaroundDays: '3-5', shippingDays: '2-4' },
  },
  {
    id: 'black-wallet',
    name: 'Black Wallet',
    category: 'wallet',
    stripeProductId: 'prod_U2x4CdqAeuxTYZ', // Stripe Live Product ID
    price: 2500, // $25.00 in cents
    frontPreviewImage: '/images/products/black-wallet/black-wallet-front-cutout-preview.png',
    backPreviewImage: '/images/products/black-wallet/black-wallet-back-cutout-preview.png',
    frontExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1772765537/engraving-products/black-wallet-base-image-v9-cutout.png',
    backExportFrame:
      'https://res.cloudinary.com/dxf6qtgxg/image/upload/v1772765537/engraving-products/black-wallet-base-image-v9-cutout.png',
    frontFrameOverlay: '/images/products/black-wallet/black-wallet-dark-frame.png',
    backFrameOverlay: '/images/products/black-wallet/black-wallet-dark-frame.png',
    frontProductionFrame: '/images/products/black-wallet/black-wallet-black-frame.png',
    backProductionFrame: '/images/products/black-wallet/black-wallet-black-frame.png',
    aiImageWidth: 864,
    aiImageHeight: 1376,
    aiDisplayWidth: 648,
    aiDisplayHeight: 1032,
    canvasWidth: 1024,
    canvasHeight: 1536,
    aspectRatio: 0.628, // 864:1376 = 54mm:86mm (portrait)
    description: 'RFID-blocking metal card holder with money clip',
    shippingInfo: { turnaroundDays: '3-5', shippingDays: '2-4' },
  },
];

/**
 * Get a product by its ID
 */
export function getProductById(id: string): Product | undefined {
  return products.find((p) => p.id === id);
}
